import * as z from 'zod/v4';
import { EnumParams } from '../events.types';
import { localizedStringSchema, rewardSchema } from './event-shared-object.schema';

export const carnivalProgressRewardBarSchema = (enums?: EnumParams) =>
  z.object({
    maxTierId: z.number().int().nonnegative().optional(),
    tiers: z.array(
      z.object({
        id: z.number().int().positive().optional(),
        pointsRequired: z.number().int().nonnegative(),
        rewards: z.array(rewardSchema(enums)),
      }),
    ),
  });

export const carnivalDayConfigItemSchema = z.object({
  name: localizedStringSchema.optional(),
  unlockDay: z.number().int().nonnegative().optional(),
  events: z.array(z.uuid()).optional(),
});

export const carnivalSectionSchema = (enums?: EnumParams) =>
  z
    .object({
      chaseHero: enums ? z.enum(enums.HeroType).optional() : z.string().optional(),
      chaseReward: rewardSchema(enums).optional(),
      days: z.number().int().default(7),
      progressRewardBar: carnivalProgressRewardBarSchema(enums),
      dayConfig: z.array(carnivalDayConfigItemSchema).optional(),
    })
    .superRefine((data, ctx) => {
      if (data.dayConfig !== undefined && data.dayConfig.length !== data.days) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: `dayConfig length (${data.dayConfig.length}) must match days (${data.days})`,
          path: ['dayConfig'],
        });
      }
    });
